import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["src", "alt", "altProps", "plain", "aspectRatio", "fit", "type", "imgProps", "borderRadius", "minHeight", "width", "height", "shadow", "dropShadow", "onError", "onClickLeft", "onClickRight", "onClickAdd", "onClickDelete", "onClick", "inspect", "position", "background", "draggable", "className", "style"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ArrowDownOutlined, ArrowLeftOutlined, ArrowRightOutlined, ArrowUpOutlined, DeleteOutlined, FileImageOutlined, PlusOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import DixuButton from "../DixuButton/DixuButton";
import DixuModal from "../DixuModal/DixuModal";
import DixuText from "../DixuText/DixuText";
import React, { useRef, useState } from 'react';
import { toRem } from "../../utils/Utils";

// Modify available aspect ratios here if needed in 'width:height' format.
const aspectRatios = ['3:2', '1:1', '4:3', '16:9', '9:16', '2:1', '32:9'];
const getAspectRatioPadding = aspectRatio => aspectRatio.split(':').reverse().reduce((height, width) => `${height / width * 100}%`);
const generatedAspectRatioPaddings = aspectRatios.reduce((acc, cur) => {
  acc[cur] = getAspectRatioPadding(cur);
  return acc;
}, {});
const DixuImage = _ref => {
  let {
      src,
      alt,
      altProps,
      plain,
      aspectRatio,
      fit,
      type,
      imgProps,
      borderRadius,
      minHeight,
      width,
      height,
      shadow,
      dropShadow,
      onError,
      onClickLeft,
      onClickRight,
      onClickAdd,
      onClickDelete,
      onClick,
      inspect,
      position,
      background,
      draggable,
      className,
      style
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    0: errored,
    1: setErrored
  } = useState(!src);
  const classes = classNames('dixu-image', className, {
    [`dixu-image--fit-${fit}`]: fit,
    [`dixu-image--type-${type}`]: type,
    [`dixu-image--position-${position}`]: position,
    [`border-radius-${borderRadius}`]: borderRadius,
    [`box-shadow-${shadow}`]: shadow,
    [`drop-shadow-${dropShadow}`]: dropShadow,
    [`bg-${background}`]: background && !errored,
    'dixu-image--draggable': draggable,
    'bg-2-4': errored
  });
  const dragMouseCoordRef = useRef({
    x: 0,
    y: 0
  });
  const activeAspectRatio = (() => {
    if (type === 'circle') {
      return undefined;
    }
    return generatedAspectRatioPaddings[aspectRatio];
  })();
  const handleError = function () {
    setErrored(true);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    onError?.(...args);
  };
  const allowInspect = inspect && !onClick;
  const handleOnClick = event => {
    if (allowInspect && event.clientX === dragMouseCoordRef.current.x && event.clientY === dragMouseCoordRef.current.y) {
      let modal;
      const onClickInspectImg = () => {
        modal.destroy();
      };
      modal = DixuModal.info({
        icon: null,
        content: /*#__PURE__*/React.createElement("img", {
          src: src,
          alt: alt,
          style: {
            display: 'block',
            maxWidth: '100%',
            cursor: 'zoom-out'
          },
          onClick: onClickInspectImg
        }),
        centered: true,
        maskClosable: true,
        contentOnly: true,
        width: 'auto'
      });
    } else {
      onClick?.(event);
    }
  };
  const assignedProps = (() => {
    const props = {
      wrapper: _objectSpread({
        className: classes,
        style: _objectSpread({
          minHeight: toRem(minHeight),
          paddingTop: height ? undefined : activeAspectRatio,
          width: toRem(width),
          height: toRem(height),
          cursor: allowInspect ? 'zoom-in' : undefined
        }, style),
        onClick: handleOnClick,
        onMouseDown: event => {
          dragMouseCoordRef.current.x = event.clientX;
          dragMouseCoordRef.current.y = event.clientY;
        }
      }, rest),
      img: {
        src,
        alt,
        loading: 'lazy',
        draggable: false
      }
    };
    if (plain) {
      props.img = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, props.img), imgProps), rest), {}, {
        style,
        onError,
        className: classNames(className, imgProps?.className)
      });
    } else {
      props.img = _objectSpread(_objectSpread({}, props.img), {}, {
        onError: handleError,
        className: classNames({
          'vhidden': errored
        })
      });
    }
    return props;
  })();
  const img = /*#__PURE__*/React.createElement("img", assignedProps.img);
  if (plain) {
    return img;
  }
  const showControls = [onClickDelete, onClickLeft, onClickAdd, onClickRight].some(Boolean);
  return /*#__PURE__*/React.createElement("div", assignedProps.wrapper, img, errored && /*#__PURE__*/React.createElement(DixuText, _objectSpread(_objectSpread({
    font: '3',
    color: '2-6',
    weight: 'bold',
    'aria-hidden': true
  }, altProps), {}, {
    block: false,
    className: classNames('dixu-image__alt', altProps?.className)
  }), alt || /*#__PURE__*/React.createElement(FileImageOutlined, null)), showControls && /*#__PURE__*/React.createElement("div", {
    className: "dixu-image__controls"
  }, onClickLeft && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuButton, {
    type: "outline",
    modifierType: "circle",
    icon: /*#__PURE__*/React.createElement(ArrowUpOutlined, null),
    block: false,
    onClick: onClickLeft,
    className: "dixu-image__control dixu-image__control--up"
  }), /*#__PURE__*/React.createElement(DixuButton, {
    type: "outline",
    modifierType: "circle",
    icon: /*#__PURE__*/React.createElement(ArrowLeftOutlined, null),
    block: false,
    onClick: onClickLeft,
    className: "dixu-image__control dixu-image__control--left"
  })), onClickAdd && /*#__PURE__*/React.createElement(DixuButton, {
    type: "outline",
    modifierType: "circle",
    icon: /*#__PURE__*/React.createElement(PlusOutlined, null),
    block: false,
    onClick: event => {
      event.stopPropagation();
      onClickAdd();
    },
    className: "dixu-image__control dixu-image__control--add"
  }), onClickRight && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuButton, {
    type: "outline",
    modifierType: "circle",
    icon: /*#__PURE__*/React.createElement(ArrowDownOutlined, null),
    block: false,
    onClick: event => {
      event.stopPropagation();
      onClickRight();
    },
    className: "dixu-image__control dixu-image__control--down"
  }), /*#__PURE__*/React.createElement(DixuButton, {
    type: "outline",
    modifierType: "circle",
    icon: /*#__PURE__*/React.createElement(ArrowRightOutlined, null),
    block: false,
    onClick: event => {
      event.stopPropagation();
      onClickRight();
    },
    className: "dixu-image__control dixu-image__control--right"
  })), onClickDelete && /*#__PURE__*/React.createElement(DixuButton, {
    type: "danger",
    modifierType: "circle",
    size: "sm",
    icon: /*#__PURE__*/React.createElement(DeleteOutlined, null),
    block: false,
    onClick: event => {
      event.stopPropagation();
      onClickDelete();
    },
    className: "dixu-image__control dixu-image__control--delete"
  })));
};
DixuImage.defaultProps = {
  src: '',
  alt: '',
  altProps: undefined,
  plain: false,
  aspectRatio: '3:2',
  fit: undefined,
  type: undefined,
  imgProps: undefined,
  borderRadius: undefined,
  minHeight: undefined,
  width: undefined,
  height: undefined,
  shadow: undefined,
  dropShadow: undefined,
  onClickLeft: undefined,
  onClickRight: undefined,
  onClickAdd: undefined,
  onClickDelete: undefined,
  inspect: false,
  position: 'center',
  background: undefined,
  draggable: false
};
export default DixuImage;